import classNames from 'classnames';
import React from 'react';
import { useState } from 'react';

interface WayshipSwitchProps {
    title: string;
    value?: boolean;
    dataKey?: string;
    isSubmit?: boolean;
    error?: any;
    onChange?: (value: boolean, dataKey?: string) => void;
    enableText?: string;
    disableText?: string;
}

export default function WayshipSwitch({
    title,
    value = false,
    dataKey,
    isSubmit = false,
    error,
    onChange,
    disableText = 'Disabled',
    enableText = 'Enabled',
}: WayshipSwitchProps) {
    const [internalValue, setInternalValue] = useState(value);
    const isOn = onChange ? value : internalValue;

    const handleToggle = () => {
        if (isSubmit) return;
        const next = !isOn;
        setInternalValue(next);
        onChange?.(next, dataKey);
    };

    return (
        <div className="flex flex-col gap-1.5 font-[system-ui]">
            <div className="flex items-center justify-between gap-4">
                {/* Label */}
                <label
                    className="ws-input__label"
                >
                    {title}
                </label>

                {/* Track + Thumb */}
                <button
                    type="button"
                    role="switch"
                    aria-checked={isOn}
                    aria-label={title}
                    disabled={isSubmit}
					onClick={handleToggle}
					className={classNames(
						'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 transition-all duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
						isSubmit
							? 'cursor-not-allowed opacity-90 border-slate-300 bg-black-200'
							: 'border-indigo-600 bg-indigo-600 focus-visible:ring-indigo-500',
					)}
				>
					{/* Thumb */}
                    <span
                        aria-hidden="true"
                        className={[
                            'inline-block h-4 w-4 rounded-full',
                            'transform transition-all duration-300 ease-in-out',
                            isOn
                                ? 'translate-x-5 bg-white shadow-indigo-200'
                                : 'translate-x-0.5 bg-white',
                        ].join(' ')}
                    />
                </button>
            </div>

            {/* Status chip */}
            <div className="flex items-center gap-1.5 pl-0.5">
                <span
                    className={
                        'transition-colors duration-300 text-fontWayship font-medium text-sm'
                    }
                >
                    {isOn ? enableText : disableText}
                </span>
            </div>

            {/* Error message */}
            {error && (
                <p className="flex items-center gap-1 text-xs text-red-500 pl-0.5">
                    {error}
                </p>
            )}
        </div>
    );
}
